import { Grid, Theme, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { FC, ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  href: string | undefined;
  mainText: string;
  secondaryText: string;
}

const StyledLink = styled('a')(({ theme }) => ({
  stroke: theme.colors.secondaryGrayText,
  color: theme.colors.secondaryGrayText,
  '&:hover': {
    stroke: theme.colors.primary,
    color: theme.colors.primary,
    cursor: 'pointer',
  },
  '&:active': {
    stroke: theme.colors.primary,
    color: theme.colors.primary,
  },
}));

export const FooterItem: FC<Props> = (props: Props) => {
  const { icon, href, mainText, secondaryText } = props;
  return (
    <StyledLink href={href} target={'_blank'} rel={'noopener noreferrer'}>
      <Grid container={true} sx={{ color: 'inherit', stroke: 'inherit' }}>
        <Grid item={true} pr={1}>
          {icon}
        </Grid>
        <Grid item={true}>
          <Typography variant={'body3'} fontSize={'13px'} fontWeight={500} color={'inherit'} component={'p'}>
            {mainText}
          </Typography>
          <Typography
            variant={'body3'}
            fontSize={'10px'}
            component={'p'}
            sx={{ color: (theme: Theme) => theme.colors.secondaryGrayText }}>
            {secondaryText}
          </Typography>
        </Grid>
      </Grid>
    </StyledLink>
  );
};
